import { useState } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Cross as Hamburger } from 'hamburger-react';
import { animateScroll as scroll, scroller } from "react-scroll";
import Home from './pages/home/Home';
import './styles/reveal.css';
import './App.css';

// Bootstrap's collapse transition; scrolling before it finishes mis-targets sections on mobile.
const NAV_COLLAPSE_MS = 350;

function App() {

  const [isNavbarExpanded, setIsNavbarExpanded] = useState(false);
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);

  const closeMobileNav = () => {
    setIsNavbarExpanded(false);
    setIsHamburgerOpen(false);
  };

  const navigateToSection = (sectionId) => {
    const shouldWaitForCollapse = isNavbarExpanded;
    closeMobileNav();

    const runScroll = () => {
      const header = document.querySelector(".site-header");
      const headerOffset = header ? -Math.ceil(header.getBoundingClientRect().height) : -72;

      scroller.scrollTo(sectionId, {
        smooth: true,
        duration: 500,
        offset: headerOffset,
      });
    };

    if (shouldWaitForCollapse) {
      window.setTimeout(runScroll, NAV_COLLAPSE_MS);
    } else {
      runScroll();
    }
  };

  return (
    <>
      <Navbar expand="lg" expanded={isNavbarExpanded} className="site-header">
        <Navbar.Brand
          as="button"
          type="button"
          className="site-wordmark"
          onClick={() => {
            scroll.scrollToTop();
            closeMobileNav();
          }}
        >
          Siraaj Fadoo
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="ml-auto"
          onClick={() => setIsNavbarExpanded(!isNavbarExpanded)}
        >
          <Hamburger color="#F5F5F5" toggled={isHamburgerOpen} toggle={setIsHamburgerOpen} size={22}></Hamburger>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto site-nav">
            <button
              type="button"
              className="nav-links"
              onClick={() => navigateToSection("about-section")}
            >
              About
            </button>
            <button
              type="button"
              className="nav-links"
              onClick={() => navigateToSection("projects-section")}
            >
              Apps
            </button>
            <button
              type="button"
              className="nav-links"
              onClick={() => navigateToSection("contact-section")}
            >
              Contact
            </button>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Router>
        <Switch>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default App;
